import { PureAbility, createMongoAbility } from '@casl/ability';
import { createContext } from 'react';

export const AbilityContext = createContext<PureAbility>(createMongoAbility());
